export default __webpack_public_path__ + "static/media/im2.8be9ea7e.jpg";